import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ptBR from '@/locales/pt-BR/translation.json';
import en from '@/locales/en/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en'],
    interpolation: { escapeValue: false },
    resources: {
      'pt-BR': { translation: ptBR },
      en: { translation: en }
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'codeshield_portal_lang'
    }
  });

export default i18n;
